import { Currency } from '@zapier/billing';

import formatPrice from './formatPrice';
import formatPriceWithCurrencySymbol from './formatPriceWithCurrencySymbol';
import { PriceFormattingOptions } from './types';

/**
 * Applies currency multiplier and formats price.
 */
const formatPriceToBeInCurrency = (
  price: number,
  currency: Currency = {
    multiplier: 1,
    name: 'USD',
    symbol: '$',
  },
  includeSymbol: boolean = true,
  formattingOptions?: Partial<PriceFormattingOptions>
): string => {
  const adjusted = price * currency.multiplier;

  return includeSymbol
    ? formatPriceWithCurrencySymbol(
        adjusted,
        formattingOptions,
        currency.symbol
      )
    : formatPrice(adjusted, formattingOptions);
};

export default formatPriceToBeInCurrency;
